(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lura-custom-painting"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindPetFilms = () => {
      document.querySelectorAll('[data-pet-film]').forEach((film) => {
        if (film.dataset.petBound) return;
        film.dataset.petBound = 'true';
        film.addEventListener('play', () => document.querySelectorAll('.lura-custom video').forEach((other) => { if (other !== film) other.pause(); }));
      });
    };
    bindPetFilms();
    document.addEventListener('shopify:section:load', bindPetFilms);
    let attempts = 0;
    const enhance = () => {
      const hosts = document.querySelectorAll('.lura-custom__request shopify-forms-embed');
      let ready = hosts.length > 0;
      hosts.forEach((host) => {
        const root = host.shadowRoot;
        if (!root) { ready = false; return; }
        if (host.dataset.luraAccessible === 'atelier-v2') return;
        host.dataset.luraAccessible = 'atelier-v2';
        const apply = () => {
          root.querySelectorAll('textarea[name]').forEach((input) => {
            if (!input.id && input.name.startsWith('custom#')) input.id = input.name;
          });
          const hints = {'first_name':'name','email':'email','custom#delivery_country':'country-name','custom#street_address_house_building_number':'address-line1','custom#apartment_suite_etc_optional':'address-line2','custom#city_town':'address-level2','custom#postal_zip_code':'postal-code','custom#state_province_region_if_applicable':'address-level1'};
          Object.entries(hints).forEach(([id, value]) => {
            const input = root.getElementById(id);
            if (input) input.autocomplete = value;
          });
          const email = root.getElementById('email');
          if (email) { email.spellcheck = false; email.inputMode = 'email'; }
          const form = root.querySelector('form');
          if (form) {
            const halves = ['first_name','email','custom#measurement_unit-selector-label','custom#dimensions_refer_to-selector-label','custom#canvas_framing-selector-label','custom#frame_colour_if_framed-selector-label','custom#city_town','custom#postal_zip_code'];
            halves.forEach((id) => {
              const input = root.getElementById(id);
              if (!input) return;
              let field = input;
              while (field.parentElement && field.parentElement !== form) field = field.parentElement;
              if (field.parentElement === form) field.dataset.luraHalf = 'true';
            });
          }
          if (!root.getElementById('lura-form-accessibility')) {
            const style = document.createElement('style');
            style.id = 'lura-form-accessibility';
            style.textContent = `
              :host{--inline-container-max-width:100%!important;--container-max-w:100%!important;--app-embed-padding-x:0!important;--app-embed-padding-y:0!important;--forms-padding-bottom:0!important;--container-text-alignment:left!important;--forms-body-font:normal 400 14px var(--font-body-family,Arial,sans-serif)!important;--forms-heading-font:normal 400 30px var(--font-heading-family,Georgia,serif)!important;--heading-font-size:30px!important;--body-text-color:#71675c!important;--heading-text-color:#382f29!important;--form-text-color:#382f29!important;--form-placeholder-color:#71675c!important;--form-background-color:#fffefa!important;--forms-accent-color:#64523f!important;--button-background-color:#40372e!important;--button-text-color:#fffdf7!important;--form-field-border-radius:0px!important;--button-border-radius:0px!important;--form-field-border:0 0 0 1px #cfc6b9!important;--form-field-border-focused:0 0 0 2px #64523f!important}
              [data-form-root]{padding:0!important}section[data-sizing="form-wrapper"]{padding:0!important}
              form[data-testid="form"]{display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr);column-gap:20px!important;row-gap:22px!important}
              form[data-testid="form"]>*{grid-column:1/-1;min-width:0}
              form[data-testid="form"]>[data-lura-half="true"]{grid-column:span 1}
              form[data-testid="form"]>div:has(>shop-lead-capture:only-child){margin:0}
              input,textarea{font-size:16px!important;color:#382f29!important}
              [class*="_formFieldContainer_"]{display:flex!important;flex-direction:column;gap:9px!important}
              [class*="_formInputFieldLabel_"]{position:static!important;order:-1;transform:none!important;inset:auto!important;font-size:13px!important;line-height:1.5!important;max-width:none!important;width:auto!important;height:auto!important;padding:0!important;margin:0!important;pointer-events:auto!important}
              input:not([type="file"]),textarea{padding:15px!important}
              input:not([type="file"]){min-height:50px}
              textarea{min-height:104px}
              label{color:#625b54!important}
              h2{line-height:1.2!important;letter-spacing:-.025em}
              [class*="_formHeader_"]{text-align:left!important;margin-bottom:6px!important}
              [class*="_formHeader_"] p{font-size:13px!important;line-height:1.7!important}
              [class*="_selectToggle_"]{min-height:50px;border-radius:0!important}
              [class*="_formFileInputField_"]{background:#f4f0e8!important;border-color:#c5b9a7!important;min-height:100px}
              [class*="_formFileInputButton_"]{background:transparent!important;text-decoration:underline;text-underline-offset:4px}
              button[type="submit"]{min-height:54px;letter-spacing:.02em}
              button[type="submit"]:hover{background:#64523f!important}
              input:focus-visible,textarea:focus-visible,button:focus-visible{outline:2px solid #64523f!important;outline-offset:3px}
              @media(max-width:699px){form[data-testid="form"]{grid-template-columns:minmax(0,1fr);row-gap:22px!important}form[data-testid="form"]>[data-lura-half="true"]{grid-column:1/-1}h2{font-size:27px!important}}
              @media(prefers-reduced-motion:reduce){*{animation:none!important;transition:none!important}}
            `;
            root.appendChild(style);
          }
        };
        apply();
        new MutationObserver(apply).observe(root, {childList:true,subtree:true});
      });
      if (!ready && ++attempts < 30) window.setTimeout(enhance, 500);
    };
    enhance();
    document.addEventListener('shopify:section:load', enhance);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lura-studio-journal"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('play', function (event) {
  const video = event.target;
  if (!(video instanceof HTMLVideoElement)) return;
  const journal = video.closest('.studio-journal');
  if (!journal) return;
  journal.querySelectorAll('video').forEach(function (other) {
    if (other !== video && !other.paused) other.pause();
  });
}, true);

  } catch(e) { console.error(e); }
})();
})();
